var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"component-tag-anchor",attrs:{"href":_vm.href,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t('common.learn_more'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }